import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { PQRAdicionaisDto, PQREncargosSociaisDto, PQRMultiplicadorAnualDto } from '../../dtos';

@Injectable({
  providedIn: 'root',
})
export class PrecoEncargosAdicionaisStateService {
  carregando = new BehaviorSubject<boolean>(true);
  
  pQREncargosSociaisPadrao: PQREncargosSociaisDto[] = [];
  pQREncargosSociaisValores: PQREncargosSociaisDto[] = [];

  pQRAdicionaisPadrao: PQRAdicionaisDto[] = [];
  pQRAdicionaisValores: PQRAdicionaisDto[] = [];

  pQRMultiplicadorAnualPadrao: PQRMultiplicadorAnualDto[] = [];
  pQRMultiplicadorAnualValores: PQRMultiplicadorAnualDto[] = [];

  constructor() {}

  setPQREncargosSociaisPadrao(data: PQREncargosSociaisDto[]): void {
    this.pQREncargosSociaisPadrao = data;
  }

  getPQREncargosSociaisPadrao(): PQREncargosSociaisDto[] {
    return this.pQREncargosSociaisPadrao;
  }

  setPQREncargosSociaisValores(data: PQREncargosSociaisDto[]): void {
    this.pQREncargosSociaisValores = data;
  }

  getPQREncargosSociaisValores(): PQREncargosSociaisDto[] {
    return this.pQREncargosSociaisValores;
  }

  setPQRAdicionaisPadrao(data: PQRAdicionaisDto[]): void {
    this.pQRAdicionaisPadrao = data;
  }

  getPQRAdicionaisPadrao(): PQRAdicionaisDto[] {
    return this.pQRAdicionaisPadrao;
  }

  setPQRAdicionaisValores(data: PQRAdicionaisDto[]): void {
    this.pQRAdicionaisValores = data;
  }

  getPQRAdicionaisValores(): PQRAdicionaisDto[] {
    return this.pQRAdicionaisValores;
  }

  setPQRMultiplicadorAnualPadrao(data: PQRMultiplicadorAnualDto[]): void {
    this.pQRMultiplicadorAnualPadrao = data;
  }

  getPQRMultiplicadorAnualPadrao(): PQRMultiplicadorAnualDto[] {
    return this.pQRMultiplicadorAnualPadrao;
  }

  setPQRMultiplicadorAnualValores(data: PQRMultiplicadorAnualDto[]): void {
    this.pQRMultiplicadorAnualValores = data;
  }

  getPQRMultiplicadorAnualValores(): PQRMultiplicadorAnualDto[] {
    return this.pQRMultiplicadorAnualValores;
  }

  //Limpa todas as projeções editadas pelo usuário quando o usuário muda de localização.
  limparValoresEditados(): void {
    this.pQREncargosSociaisValores = [];
    this.pQRAdicionaisValores = [];
    this.pQRMultiplicadorAnualValores = [];
  }
}
